//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'BurnFluidReplacement',
  data() {
    return {
      form:{
        method: 1,
        burn_area:'',
        weight:'',
        time:'',
        replenished:'',
      },
      dataList1: [
        { value: 1, name: '成人' },
        { value: 2, name: '儿童' },
        { value: 3, name: '婴儿' },
      ],
      hasScore:false,
      disabled:false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
    exclusiveChild(item, index) {
      this.form.method = item.value;
    }
  },
  computed: {
    /** 计算主要标准 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key]=='---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        let fluid = form.method == 1 ? 1.5 : form.method == 2 ? 1.8 : 2
        let result24 = 0
        let result24_1 = 0
        let result24_2 = 0

        if (form.method == 1) { // 成人
          result24 = form.burn_area * form.weight * fluid + 2000
        } else if (form.method == 2) { // 儿童
          result24_1 = Number(form.burn_area * form.weight * fluid + 70 * form.weight)
          result24_2 = Number(form.burn_area * form.weight * fluid + 100 * form.weight)
        } else { // 婴儿
          result24_1 = Number(form.burn_area * form.weight * fluid + 100 * form.weight)
          result24_2 = Number(form.burn_area * form.weight * fluid + 150 * form.weight)
        }

        let prev = 0
        let prev1 = 0
        let prev2 = 0

        let next = 0
        let next1 = 0
        let next2 = 0

        if (form.time < 8) {
          if (form.method == 1) {
            prev = result24 * (1/2 * (form.time / 8)) - form.replenished
            next = result24  - prev - form.replenished
          } else {
            prev1 = result24_1 * (1/2 * (form.time / 8)) - form.replenished
            next1 = result24_1  - prev1 - form.replenished

            prev2 = result24_2 * (1/2 * (form.time / 8)) - form.replenished
            next2 = result24_2  - prev2 - form.replenished
          }
        }else {
          if (form.method == 1) {
            prev = result24 * (1/2 + ((form.time - 8) / 16) * 1/2) - form.replenished
            next = result24  - prev - form.replenished
          } else {
            prev1 = result24_1 * (1/2 + ((form.time - 8) / 16) * 1/2) - form.replenished
            next1 = result24_1  - prev1 - form.replenished

            prev2 = result24_2 * (1/2 + ((form.time - 8) / 16) * 1/2) - form.replenished
            next2 = result24_2  - prev2 - form.replenished
          }
        }
        self.hasScore = true


        // 补液量已足够
        if (prev < 0) {
          prev = 0
          next = result24 - form.replenished
        } else {
          next = result24 - prev - form.replenished
        }
        if (next < 0) {
          next = 0
        }

        // 补液量已足够
        if (prev1 < 0) {
          prev1 = 0
          next1 = result24_1 - form.replenished
        } else {
          next1 = result24_1 - prev1 - form.replenished
        }
        if (next1 < 0) {
          next1 = 0
        }

        // 补液量已足够
        if (prev2 < 0) {
          prev2 = 0
          next2 = result24_2 - form.replenished
        } else {
          next2 = result24_2 - prev2 - form.replenished
        }
        if (next2 < 0) {
          next2 = 0
        }

        return {
          fluid24: form.method == 1 ? String(result24) : String(result24_1) + '~' + String(result24_2),
          fluid_prev: form.method == 1 ? String(prev == 0 ? '补液量已足够' : prev.toFixed(2)) : prev1 == 0 && prev2 == 0 ? '补液量已足够' : String(prev1.toFixed(2)) + '~' + String(prev2.toFixed(2)),
          fluid_next: form.method == 1 ? String(next == 0 ? '补液量已足够' : next.toFixed(2)) : next1 == 0 && next2 == 0 ? '补液量已足够' : String(next1.toFixed(2)) + '~' + String(next2.toFixed(2))
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Trauma/BurnFluidReplacement.vue